import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Col, Card, CardBody, CardTitle, Button, Progress } from "reactstrap";
// import DropDownActions from "../../common/DropDownActions";
import {
  getWorkExperience,
  updatePreviousProjectList,
  addPreviousProjectList,
  deletePreviousProjectList,
} from "../../../redux/actions/employee/employee.action";
import {
  PopUp,
  PopUpSuccess,
} from "../../../components/adminSettings/assets/index";
import Notifications from "../../../components/common/Notifications";
import api from "../../../apis/api";
import AddEditFormPreviousProject from "./AddEditFormPreviousProject";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
const CardViewPreviousProjects = React.memo((props) => {
  const {
    getWorkExperience,
    updatePreviousProjectList,
    addPreviousProjectList,
    deletePreviousProjectList,
    employeeId,
  } = props;
  const { empworkexp } = props.empworkexp;

  const [isOpenEditForm, setIsOpenEditForm] = useState(false);
  const [selectedpreviousprojects, setSelectedpreviousprojects] = useState("");
  const [isopenpopup,setisopenpopup]=useState(false);
  const [isopenpopupSuccess,setisopenpopupSuccess]=useState(false);
  const [curDelId,setcurDelId] =useState(0);
  const [val,setval]=useState({value :"",label:""});
  const [error, setError] = useState(null);
  const [workexperienceDate,setworkexperienceDate] =useState([]);
  const [loaded, setLoaded] = useState(false);
   
const DarkBackground = styled.div`
display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
${(props) =>
  props.disappear &&
  css`
    display: block; /* show */
  `}
`;
  useEffect(() => {
    getWorkExperience(employeeId);
  }, [getWorkExperience]);
useEffect(() =>{
  setworkexperienceDate(empworkexp);
})
  const toggleForm = React.useCallback(() => {
     setSelectedpreviousprojects({});
    setIsOpenEditForm((prevState) => !prevState);
  }, [setIsOpenEditForm]);

  const handleProjectEdit = React.useCallback((project) => {
    setSelectedpreviousprojects(project);
    setIsOpenEditForm((prevState) => !prevState);
  }, [setIsOpenEditForm,setSelectedpreviousprojects]);

  const updatePreviousProject = React.useCallback(
    (formData) => {
      updatePreviousProjectList(formData);
      setError({ ...error, message: "Previous project details updated successfully...", status: 200 });
    },
    [updatePreviousProjectList]
  );

  const addPreviousProject = React.useCallback(
    (formData) => {
      setLoaded(true);
      addPreviousProjectList(formData);
     
      setTimeout(() => { 
        getWorkExperience(employeeId);
        setworkexperienceDate(empworkexp);
        setLoaded(false);
    }, 3000);
  
      setError({ ...error, message: "Previous project details added successfully...", status: 200 });
    },
    [addPreviousProjectList,getWorkExperience,employeeId,empworkexp,setworkexperienceDate]
  );

  const handleClickDeletePreviousProjects = (workExperienceId) => {
    setisopenpopup((prevState) => !prevState);
    setcurDelId(workExperienceId);

    
  };
  const hadleDelWithPopYes =React.useCallback(() =>{
    // const res= delOfficeLoation(curDelId);
    deletePreviousProjectList(curDelId);
    
    setisopenpopup((prevState) => !prevState);
    setisopenpopupSuccess((prevState) => !prevState);
    // window.location.reload();
   
    }, [deletePreviousProjectList,curDelId]);
  
  const hadleDelWithPopNo =React.useCallback(() =>{
   setisopenpopup((prevState) => !prevState);
  
  });
    
  const hadleSuccessPop =React.useCallback(() =>{
    const fetchApi = async () => {
      let array=[];
      // await api.task().GetAllTaskByProjectId(parseInt(selProjectId)).then((res) => array.push(res.data));
      await api.dbworkexperience().GetPreviousProject(employeeId).then((res) => array.push(res.data));
      setSelectedpreviousprojects(array[0]);
     
    }
    fetchApi();
     setError({ ...error, message: "Previous project details deleted successfully...", status: 200 });
   setisopenpopupSuccess((prevState) => !prevState);
  
  },[setSelectedpreviousprojects]);
  return (
    <Fragment>
      {isOpenEditForm ? (
        <AddEditFormPreviousProject
          {...props}
          prevprojects={selectedpreviousprojects}
          toggleForm={toggleForm}
          updatePreviousProject={updatePreviousProject}
          addPreviousProject={addPreviousProject}
        ></AddEditFormPreviousProject>
      ) : (
        workexperienceDate.map((project, i) => (
          <Col key={i} md={4} sm={6} xl={3}>
            <Card className="project-crad mb-4">
              <CardBody>
                <CardTitle>
                  <h4 className="project-title">
                    {/* <a href="#" onClick={() => handleProjectEdit(project)}> */}
                      {project.projectName}
                    {/* </a> */}
                    <div className="edit-del-icon " style={{float : 'right'}}>
                    <span
                      style={{float : 'right'}}
                        className="del"
                        onClick={() =>
                          handleClickDeletePreviousProjects(
                            project.workExperienceId
                          )
                        }
                      >
                        <i className="fas fa-trash"></i>
                      </span>
                    <span
                      href="#"
                      className="edit-icon"
                      onClick={() => handleProjectEdit(project)}
                      
                    >
                      <i className="fas fa-pencil-alt"></i>
                    </span>
                      
                    </div>
                  </h4>
                </CardTitle>
                <span className="text-muted mt-3 project-description">
                  {project.description}
                </span>
                <div className="mt-3">
                  <h4 className="project-title mb-1">Role :</h4>
                  <div className="text-muted">{project.role}</div>
                </div>
                <div className="mt-3">
                  <h4 className="project-title">Environment :</h4>
                  <div className="text-muted">{project.environment}</div>
                </div>
                <div className="mt-3">
                  <h4 className="project-title">Technologies :</h4>
                  <div className="text-muted">{project.technologies}</div>
                </div>
                <div className="mt-3">
                  <h4 className="project-title">Description :</h4>
                  <div className="text-muted">{project.description}</div>
                </div>
              </CardBody>
            </Card>
            <Button
              color="primary"
              outline
              className="skill-add-btn"
              onClick={() => {
                setSelectedpreviousprojects({});
                toggleForm();
              }}
            >
              <i className="fa fa-plus"></i>
            </Button>
          </Col>
        ))
      )}
       <Button color="primary" id="addPreviousProject" style={{background : "#007bff",width:"70px",height :"47px"}} outline className="skill-add-btn" onClick={toggleForm}>
        <i className="fa fa-plus" style={{color:"white"}}></i>
      </Button>
      <Notifications notifications={error}></Notifications>
      {isopenpopup == true ? (<PopUp 
    
    hadleDelWithPopYes={hadleDelWithPopYes}
    hadleDelWithPopNo={hadleDelWithPopNo}
    >

</PopUp>) : null}        
{isopenpopupSuccess == true ? (<PopUpSuccess 
    hadleSuccessPop={hadleSuccessPop}
    >

</PopUpSuccess>) : null}
<DarkBackground disappear={loaded}>
    <LoadingOverlay
          active={true}
          spinner={true}
          text="Loading your content..."
        >
        </LoadingOverlay>
    </DarkBackground>
    </Fragment>
  );
});

const mapStateToProps = (state) => ({
  empworkexp: state.empReducer,
});

export default connect(mapStateToProps, {
  getWorkExperience,
  updatePreviousProjectList,
  addPreviousProjectList,
  deletePreviousProjectList,
})(CardViewPreviousProjects);
